<template>
	<el-input v-if="model"
			  v-model="model[data.fieldId]"
			  :placeholder="data.placeholder"
			  :prefix-icon="data.setting.prefixIcon"
			  :suffix-icon="data.setting.suffixIcon"
			  :maxlength="data.maxlength"
			  :show-word-limit="data.showWordLimit"
			  v-input-filter="data.filter"
			  @change="inputChange">
		<el-button slot="append"
				   v-if="data.isHaveUnit">{{data.unitName}}</el-button>
		<template slot="prepend" v-if="prependShow">
			<componentPrepend></componentPrepend>
		</template>
		<template slot="append" v-if="suffixShow">
			<componentSuffix></componentSuffix>
		</template> 
	</el-input>
	<el-input v-else
			  v-model="data.value"
			  :placeholder="data.placeholder"
			  :prefix-icon="data.setting.prefixIcon"
			  :suffix-icon="data.setting.suffixIcon"
			  :maxlength="data.maxlength"
			  :show-word-limit="data.showWordLimit"></el-input>
</template>

<script>
import Vue from 'vue'
import inputFilter from '../../utils/input-filter/index.js'
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpInput',
	inject: [ 'customFormOptions', 'componentChange' ],
	directives: {
		inputFilter
	},
	provide() {
		return {
			componentPrependChange: this.componentPrependChange,
			componentSuffixChange: this.componentSuffixChange
		}
	},
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	computed: {
		prependShow() {
			return isHaveKey(this.customFormOptions[this.data.fieldId], 'component_prepend')
		},

		suffixShow() {
			return isHaveKey(this.customFormOptions[this.data.fieldId], 'component_suffix')
		}
	},
	methods: {
		componentPrependChange(val) {
			this.componentChange(this.data.fieldId, val)
		},

		componentSuffixChange(val) {
			this.componentChange(this.data.fieldId, val)
		},

		inputChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	},
	created() {
		if (this.prependShow) {
			let _this = this
			Vue.component('componentPrepend', {
				render(createElement) {
					if (isHaveKey(_this.customFormOptions[_this.data.fieldId], 'component_prepend')) {
						return createElement(_this.customFormOptions[_this.data.fieldId].component_prepend.default)
					} else {
						console.error('component_prepend is undefined')
					}
				}
			})
		}
		if (this.suffixShow) {
			let _this = this
			Vue.component('componentSuffix', {
				render(createElement) {
					if (isHaveKey(_this.customFormOptions[_this.data.fieldId], 'component_suffix')) {
						return createElement(_this.customFormOptions[_this.data.fieldId].component_suffix.default)
					} else {
						console.error('component_suffix is undefined')
					}
				}
			})
		}
	}
}
</script>